module.exports = __webpack_public_path__ + "img/LI107358.1e868a85.png";